
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default{
components: {
Group,
CellBox,
Tab,
TabItem,
Flexbox,
FlexboxItem,
XButton,
Popover,
Loading
},
data(){
return{
tabsParam:[['正在学习',"course1"],['历史课程',"course2"]],
demo:"正在学习",
nowIndex:0,//默认第一个tab为激活状态
isCourse:[""],
hisCourse:[""],
WebUrl:""
}
},
beforeMount(){

this.$vux.loading.show({
text: 'Loading'
})

this.toggleTabs(0);

this.WebUrl = this.$api.URL;

setTimeout(() => {
this.$vux.loading.hide()
}, 1000)
},
methods:{
toggleTabs:function(index){
switch (index){
case 0:
this.getMyCourse(false);
break;
case 1:
this.getMyCourse(true);
break;
}


this.$vux.loading.show({
text: 'Loading'
})

this.nowIndex=index;


setTimeout(() => {
this.$vux.loading.hide()
}, 300)
},

getMyCourse:function(type){
if(type){
this.$api.UserVideo("true")
.then((data)=>{
if(data.data.Status!=0){
return ;
}
var json = data.data.Data.rows;
this.hisCourse = json;

})
}else{
this.$api.UserVideo("false")
.then((data)=>{
if(data.data.Status!=0){
return ;
}
var json = data.data.Data.rows;
this.isCourse = json;
})
}
},

deleteCourse:function(){
var progressID = event.target.id;
var deleteSure = confirm("确认删除？")

if(deleteSure){
this.$api.DeleteCourse(progressID)
.then((data)=>{
if(data.data.Status==0){
return ;
}else{
alert("删除成功")
this.getMyCourse(false);
}
})
}

},

toCourse:function(){
var id = event.target.id;
this.$router.push({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: id,
level1: "我的课程",
}
})

}
}
}



// WEBPACK FOOTER //
// ./src/views/Personal/MyCourse.vue